import styled from 'styled-components';

import { Flex } from '@/components/Flex';
import { NextImage } from '@/components/NextImage';
import { px2rem } from '@/theme';

export const PriceWrapper = styled(Flex)`
  cursor: pointer;
  margin-top: ${px2rem(4)};
`;

export const Icon = styled(NextImage)`
  color: ${({ theme }) => theme.colors.primary};
  margin-left: ${px2rem(4)};
`;
